import React from "react";
import { Row, Col, Typography, Tooltip, Progress } from "antd";
import ConsumerApplicationProgressBar from "../views/ConsumerProject/Consumer/ConsumerApplicationProgressBar";
import ConsumerShowApplicationId from "../views/ConsumerProject/Consumer/ConsumerShowApplicationId";
import "./ApplicationHeader.css";

const { Title, Text } = Typography;

const ApplicationHeader = ({ 
    currentStep, 
    stepTitle, 
    showProgress = false,
    progressPercent = 0,
    showApplicationId = false 
}) => {
    return (
        <Row gutter={[24, 16]} className="application-header-row">
            {/* Section 1: Step Info */}
            <Col xs={24} md={12}>
                <div>
                    {/* <Title level={5} className="application-header-step-number">
                        Step {currentStep}
                    </Title>
                    <Text strong className="application-header-step-title">
                        {stepTitle}
                    </Text> */}
                </div>
            </Col>

            {/* Section 2: Application ID & Progress */}
            <Col xs={24} md={12}>
                {showProgress ? (
                    // <div className="application-header-section progress-info">
                    <div>
                        <Text type="secondary" className="application-header-label with-space">
                            Application Progress
                        </Text>
                        <Tooltip title={`Application Workflow Progress: ${progressPercent}%`}>
                            <ConsumerApplicationProgressBar />
                        </Tooltip>
                    </div>
                ) : showApplicationId ? (
                    // <div className="application-header-section progress-info">
                    <div>
                        {/* <Text type="secondary" className="application-header-label">
                            Application ID
                        </Text> */}
                        <Title level={5} className="application-header-step-title">
                            <ConsumerShowApplicationId />
                        </Title>
                        <ConsumerApplicationProgressBar />
                    </div>
                ) : null}
            </Col>
        </Row>
    );
};

export default ApplicationHeader;
